// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { useAuth } from "./AuthContext";
// import { useState, useEffect, useRef } from "react";
// import { ChevronDownIcon } from '@heroicons/react/20/solid'; // ✅ Requires heroicons

// export default function SharedHeader() {
//   const { userId, userEmail, userName, logout } = useAuth();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [menuOpen, setMenuOpen] = useState(false);
//   const menuRef = useRef(null);

//   const currentPath = location.pathname;

//   const handleLogout = () => {
//     logout();
//     navigate("/");
//   };

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         setMenuOpen(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const displayName = userName || userEmail || "User";
//   const userInitial = displayName.charAt(0).toUpperCase();

//   return (
//     <header className="bg-blue-600 text-white px-6 py-4 shadow-md flex justify-between items-center">
//       <h1 className="text-2xl font-bold tracking-wide">Gatiii</h1>

//       <nav className="flex gap-3 items-center relative">
//         {!userId ? (
//           <>
//             {currentPath !== "/signup" && (
//               <Link
//                 to="/signup"
//                 className="bg-white text-blue-600 font-semibold px-4 py-2 rounded-full hover:bg-gray-100 transition"
//               >
//                 Signup
//               </Link>
//             )}
//             {currentPath !== "/forgot-password" && (
//               <Link
//                 to="/forgot-password"
//                 className="text-sm underline underline-offset-4 hover:text-gray-200 transition"
//               >
//                 Forgot Password?
//               </Link>
//             )}
//           </>
//         ) : (
//           <div className="relative" ref={menuRef}>
//             <button
//               onClick={() => setMenuOpen((prev) => !prev)}
//               className="flex items-center gap-2 bg-white text-blue-600 font-semibold px-4 py-2 rounded-full hover:bg-gray-100 transition"
//             >
//               <span className="w-8 h-8 rounded-full bg-blue-200 text-blue-800 flex items-center justify-center font-bold text-sm">
//                 {userInitial}
//               </span>
//               <span className="hidden sm:inline">{displayName}</span>
//               <ChevronDownIcon className="w-5 h-5" />
//             </button>

//             {menuOpen && (
//               <div className="absolute right-0 mt-2 bg-white text-blue-600 rounded shadow-md w-40 z-10">
//                 <button
//                   onClick={handleLogout}
//                   className="block w-full text-left px-4 py-2 hover:bg-gray-100"
//                 >
//                   Logout
//                 </button>
//               </div>
//             )}
//           </div>
//         )}
//       </nav>
//     </header>
//   );
// }
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { useState, useEffect, useRef } from "react";
import { ChevronDownIcon } from '@heroicons/react/20/solid';

export default function SharedHeader() {
  const { userId, userEmail, userName, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const currentPath = location.pathname;
  const isLandingPage = currentPath === "/";

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const displayName = userName || userEmail || "User";
  const userInitial = displayName.charAt(0).toUpperCase();

  return (
    <header className="bg-blue-600 text-white px-6 py-4 shadow-md flex justify-between items-center">
      <h1
        className="text-2xl font-bold tracking-wide cursor-pointer"
        onClick={() => navigate("/")}
      >
        Gatiii
      </h1>

      <nav className="flex gap-3 items-center relative">
        {!userId ? (
          <>
            {/* On the landing page, the page itself has Login/Signup CTAs — don't duplicate here */}
            {!isLandingPage && currentPath !== "/signup" && (
              <Link
                to="/signup"
                className="bg-white text-blue-600 font-semibold px-4 py-2 rounded-full hover:bg-gray-100 transition"
              >
                Signup
              </Link>
            )}
            {!isLandingPage && currentPath !== "/forgot-password" && (
              <Link
                to="/forgot-password"
                className="text-sm underline underline-offset-4 hover:text-gray-200 transition"
              >
                Forgot Password?
              </Link>
            )}
          </>
        ) : (
          <div className="relative" ref={menuRef}>
            <button
              onClick={() => setMenuOpen((prev) => !prev)}
              className="flex items-center gap-2 bg-white text-blue-600 font-semibold px-4 py-2 rounded-full hover:bg-gray-100 transition"
            >
              <span className="w-8 h-8 rounded-full bg-blue-200 text-blue-800 flex items-center justify-center font-bold text-sm">
                {userInitial}
              </span>
              <span className="hidden sm:inline">{displayName}</span>
              <ChevronDownIcon className="w-5 h-5" />
            </button>

            {menuOpen && (
              <div className="absolute right-0 mt-2 bg-white text-blue-600 rounded shadow-md w-40 z-10">
                <button
                  onClick={handleLogout}
                  className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        )}
      </nav>
    </header>
  );
}
